/**
 * @Author : zhouqinze
 * @Date : 2020-1-3
 * @Version : 1.0
 * @Content : 数字交通
 **/
<template>
    <div class="traCon">
        <div class="banner"></div>
        <div class="topText">
            <h3>智慧化管理与服务</h3>
            <p>为数字交通政务提供解决方案、课题研究、软件开发、实施推广服务</p>
        </div>
        <div class="topBox" ref="topBox">
            <div class="topHead">
                <div class="traLeft">
                    <img src="http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_jtgjys.png" alt="">
                    <img src="http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_zh.png" alt="">
                    <img src="http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_jtzwfw.png" alt="">
                </div>
                <div class="traRight">
                    <div class="rightBox" :style="{background:this.bgColorCom}">
                        <div class="rightIcon"></div>
                        <div class="rightText">交通关键要素数字化</div>
                        <div class="rightBottom"></div>
                    </div>
                    <div class="rightBox" :style="{background:this.bgColorCom}">
                        <div class="rightIcon"></div>
                        <div class="rightText">交通政务管理数字化</div>
                        <div class="rightBottom"></div>
                    </div>
                    <div class="rightBox" :style="{background:this.bgColorCom}">
                        <div class="rightIcon"></div>
                        <div class="rightText">交通政务服务数字化</div>
                        <div class="rightBottom"></div>
                    </div>
                </div>
            </div>
            <div class="rightBoxBtm">
                <div class="btmItem">
                        <div class="rightIcon"></div>
                    <div class="rightText">交通政务管理与服务的智慧化</div>
                    <div class="rightBottom"></div>
                </div>
            </div>
            <!-- <div class="box3" id="box3">
            <div id="H7FocusImages">
              <img
                id="product1"
                class="threed"
                src="https://gooddriver.oss-cn-hangzhou.aliyuncs.com/Web2020/hud/hud_c_01.jpg"
              />
              <img
                id="product2"
                class="threed"
                src="https://gooddriver.oss-cn-hangzhou.aliyuncs.com/Web2020/hud/hud_c_02.jpg"
              />
              <img
                id="product3"
                class="threed"
                src="https://gooddriver.oss-cn-hangzhou.aliyuncs.com/Web2020/hud/hud_c_03.jpg"
              />
            </div>
            <div id="H7FocusTexts">
              <div class="text black" data-wow-delay="300ms">
                <img
                  class="an"
                  src="https://gooddriver.oss-cn-hangzhou.aliyuncs.com/Web2020/hud/icon_location.png"
                />
                <h1 class="an">即使不在身边，我也会认真守护</h1>
                <p class="an">爱车外借，打开优驾App，可实时查看行车位置</p>
              </div>
              <div class="text" data-wow-delay="300ms">
                <img
                  class="an"
                  src="https://gooddriver.oss-cn-hangzhou.aliyuncs.com/Web2020/hud/icon_more.png"
                />
                <h1 class="an">想给你的，还有更多</h1>
                <p class="an">极简风？炫酷范？多主题炫酷仪表，总有一款是你心头好</p>
              </div>
              <div class="text" data-wow-delay="300ms">
                <img
                  class="an"
                  src="https://gooddriver.oss-cn-hangzhou.aliyuncs.com/Web2020/hud/icon_jl.png"
                />
                <h1 class="an">你曾走过的每一步，都值得铭记</h1>
                <p class="an">行车数据实时记录，历史轨迹一键查询</p>
              </div>
            </div>
          </div> -->
        </div>
        <div class="midBox">
            <div class="midText"><h3>主要解决方案</h3><p>国内智慧交通运输政务领域专家及领导者，深耕交通运输业务</p><p>覆盖全领域的交通运输业务系统</p></div>
            <div class="midCon">
                <div class="conBox">
                    <img src="http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_zhhd.png" alt="">
                    <h3 style="text-align:center">智慧航道</h3>
                     <p style="text-align:center;padding-right: 1.875em;">● 全过程数字化办理</p>
                     <p style="text-align:center;padding-right: 1.875em;">● 水运资源融通融合</p>
                     <p style="text-align:center;padding-right: 1.875em;">● 航运动态全面感知</p>
                     <p style="text-align:center">● 水运一体化智能管理</p>
                     <p style="text-align:center">● 全方位监控智能决策</p>
                </div>
                <div class="conBox">
                    <img src="http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_zhzf.png" alt="">
                    <h3 style="text-align:center">综合执法</h3>
                     <p style="text-align:center">● 十年经验成熟积累</p>
                     <p style="text-align:center">● 全国领先技术应用</p>
                     <p style="text-align:center">● 全面覆盖执法业务</p>
                     <p style="text-align:center">● 执法管理有效抓手</p>
                     <p style="text-align:center">● 提高效能高效工具</p>
                </div>
                <div class="conBox">
                    <img src="http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_znjk.png" alt="">
                    <h3 style="text-align:center">智能监控</h3>
                     <p style="text-align:center;padding-right: 1.875em;">● 全面的视觉感知能力</p>
                     <p style="text-align:center;padding-right: 1.875em;">● 高精准视觉识别技术</p>
                     <p style="text-align:center;padding-right: 1.875em;">● 位置和状态精准获取</p>
                     <p style="text-align:center">● 车辆多维特征精细感知</p>
                     <p style="text-align:center">● 人脸多维特征精准识别</p>
                </div>
                <div class="conBox">
                    <img src="http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_xtcx.png" alt="">
                    <h3 style="text-align:center">协同创新</h3>
                     <p style="text-align:center">● 高起点、宽视野、辅决策</p>
                     <p style="text-align:center">● 动态的、互动的、智慧的</p>
                     <p style="text-align:center;padding-right: 1.875em;">● 整合各类交通科研资源</p>
                     <p style="text-align:center;padding-right: 1.875em;">● 全链条闭环的科技管理</p>
                     <p style="text-align:center;padding-right: 1.875em;">● 交通运输协同创新服务</p>
                </div>
            </div>
        </div>
        <div class="advantage">
            <div class="content">
                <div class="advText">
                    <h3>业务与技术优势</h3>
                    <p>二十年积累沉淀，筑立新时代数字交通标杆，以创新实践助力交通运输数字政务</p>
                    <p>50+专利与软件著作权</p>
                </div>
                <div class="advCon">
                    <div class="advBox">
                        <div class="advNor">
                            <div>
                                <!-- <img src="http://comit.oss-cn-hangzhou.aliyuncs.com/img/icon_jthyzj.png" alt=""> -->
                                <div class="icon"></div>
                                <p>交通行业专家</p>
                            </div>
                        </div>
                        <div class="advAct">
                                <div class="icon"></div>
                            <h3>交通行业专家</h3>
                            <p>交通运输管理电子政务全方位服务、全国首套港口危险货物作业全周期管理系统、全国首套交通运输综合行政执法管理系统</p>
                        </div>
                    </div>
                    <div class="advBox">
                        <div class="advNor">
                            <div>
                                <div class="icon"></div>
                                <p>交通数据资源整合技术</p>
                            </div>
                        </div>
                        <div class="advAct">
                                <div class="icon"></div>
                            <h3>交通数据资源整合技术</h3>
                            <p>整合公路资源数据资源，建设广东公路交通数据中心；整合水路数据资源，建设广东水路交通数据中心</p>
                        </div>
                    </div>
                    <div class="advBox">
                        <div class="advNor">
                            <div>
                                <div class="icon"></div>
                                <p>交通空间地理信息技术</p>
                            </div>
                        </div>
                        <div class="advAct">
                                <div class="icon"></div>
                            <h3>交通空间地理信息技术</h3>
                            <p>提供交通一张图服务、提供车联网地图解决方案、提供船联网地图解决方案、首批ArcGIS全球战略合作伙伴单位</p>
                        </div>
                    </div>
                    <div class="advBox">
                        <div class="advNor">
                            <div>
                                <div class="icon"></div>
                                <p>交通移动开发技术</p>
                            </div>
                        </div>
                        <div class="advAct">
                                <div class="icon"></div>
                            <h3>交通移动开发技术</h3>
                            <p>“优驾”智能用车领导品牌、“粤e航管”全国领先的航运APP、“广东交通执法”全国首款交通综合执法APP、“掌上粤交科”全国领先的无纸化会议系统</p>
                        </div>
                    </div>
                    <div class="advBox">
                        <div class="advNor">
                            <div>
                                <div class="icon"></div>
                                <p>AI人工智能深度应用</p>
                            </div>
                        </div>
                        <div class="advAct">
                                <div class="icon"></div>
                            <h3>AI人工智能深度应用</h3>
                            <p>优驾人工智能助手</p>
                        </div>
                    </div>
                    <div class="advBox">
                        <div class="advNor">
                            <div>
                                <div class="icon"></div>
                                <p>交通大数据技术深度实践</p>
                            </div>
                        </div>
                        <div class="advAct">
                                <div class="icon"></div>
                            <h3>交通大数据技术深度实践</h3>
                            <p>驾驶出行大数据应用、船舶AIS大数据分析挖掘应用、道路运输车辆检测大数据分析应用</p>
                        </div>
                    </div>
                    <div class="advBox">
                        <div class="advNor">
                            <div>
                                <div class="icon"></div>
                                <p>区块链技术落地实践</p>
                            </div>
                        </div>
                        <div class="advAct">
                                <div class="icon"></div>
                            <h3>区块链技术落地实践</h3>
                            <p>基于区块链技术的航运指数系统设计、利用区块链技术创造汽车数据价值的未来生态、基于大数据和区块链的果蔬溯源系统应用</p>
                        </div>
                    </div>
                    <div class="advBox">
                        <div class="advNor">
                            <div>
                                <div class="icon"></div>
                                <p>物联网技术全面应用</p>
                            </div>
                        </div>
                        <div class="advAct">
                            <div class="icon"></div>
                            <h3>物联网技术全面应用</h3>
                            <p>优驾智能车盒、智能水深测深仪、优驾双智能后视镜</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="service">
            <div class="content">
                <div class="serText">
                    <h3>专业服务</h3>
                    <p>优秀专业团队，提供高效、快速的优质服务</p>
                </div>
                <div class="serCon">
                    <div class="serBox">
                        <img src="http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_ywzx.png" alt="">
                        <div>
                            <h3>专业业务咨询服务</h3>
                            <span></span>
                        </div>
                         <p style="text-align:center">● 业务梳理咨询</p>
                         <p style="text-align:center">● 管理方案咨询</p>
                         <p style="text-align:center">● 系统建设咨询</p>
                    </div>
                    <div class="serBox">
                        <img src="http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_dzkf.png" alt="">
                        <div>
                            <h3>高效定制开发服务</h3>
                            <span></span>
                        </div>
                         <p style="text-align:center">● 高效需求调研</p>
                         <p style="text-align:center">● 精准需求定义</p>
                         <p style="text-align:center">● 快速定制开发</p>
                    </div>
                    <div class="serBox">
                        <img src="http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_kstg.png" alt="">
                        <div>
                            <h3>快速推广实施服务</h3>
                            <span></span>
                        </div>
                         <p style="text-align:center;padding-right: 1em;">● 数据初始化</p>
                         <p style="text-align:center">● 专业培训讲师</p>
                         <p style="text-align:center">● 全程跟踪服务</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            scrollTop: 0,// 滚动条的高度
        }
    },
    mounted(){
        this.$refs.topBox.addEventListener('scroll',this.Scroll,false)
    },
    methods: {
    // 滚动事件,绑定到元素div块
    // 如果不绑定到元素上，则只能监听页面滚动
        Scroll(){
            // window.console.log(this.$refs.topBox.scrollTop)
            // window.console.log(this.$refs)
            this.scrollTop = this.$refs.topBox.scrollTop
            // return this.$refs.topBox.scrollTop
        }
    },
    computed: {
        bgColorCom:function(){
            // let top = this.Scroll()
            let bgColor = '#DCDCDC'
            if(this.scrollTop > 0){
                bgColor = '#DCDCDC'
            }
            if(this.scrollTop > 790){
                bgColor = '#018CF4'
            }
            if(this.scrollTop > 1580){
                bgColor = '#222'
            }
            return bgColor
        }
    },
    beforeDestroy() {
        this.$refs.topBox.removeEventListener('scroll', this.Scroll)
    },
    // destroyed () {
    //     // 离开该页面需要移除这个监听的事件，不然会报错
    //     this.$refs.topBox.removeEventListener('scroll', this.Scroll)
    //     // window.delete.this.$refs.topBox.addEventListener('scroll', this.Scroll,false)
    // }
}
</script>

<style lang="scss" scoped>
    .traCon{
            overflow-x: hidden;
        .banner{
            width: 100%;
            height: 47.5rem;
            background: url(http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_banner_szjt.png) no-repeat center center;
            background-size: 100% 100%;
        }
        .topText{
            height: 17.1875rem;
            text-align: center;
            display: flex;
            flex-direction: column;
            justify-content: center;
            h3{
                font-size: 2.625rem;
                line-height: 2.625rem;
                color: #333;
                margin-bottom: 1.625rem;
            }
            p{
                font-size: 1.375rem;
                line-height: 1.375rem;
                color: #666;
            }
        }
        .topBox::-webkit-scrollba{
            display: none;
        }
        .topBox{
            height: 49.375rem;
            // display: flex;
            overflow: scroll;
            overflow-x: hidden;
            width: 102%;
            .rightBoxBtm{
                height: 49.375rem;
                width: 100%;
                background: url(http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_zhh.png) no-repeat center center;
                background-size: 100% 100%;
                position: relative;
                color: #fff;
                padding-left: 25%;
                box-sizing: border-box;
                .btmItem{
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    .rightIcon{
                        width: 3.75rem;
                        height: 3.75rem;
                        background-image: url(http://comit.oss-cn-hangzhou.aliyuncs.com/img/icon_zhh.png);
                        background-repeat: no-repeat;
                        background-size: 100% 100%;
                        background-position: center center;
                        margin-bottom: 2.625rem;
                    }
                    .rightText{
                        height: 2.1875rem;
                        line-height: 2.1875rem;
                        box-sizing: border-box;
                        font-size: 2.1875rem;
                        margin-bottom: 2.3125rem;
                        text-align: left;
                    }
                    .rightBottom{
                        width: 3.5rem;
                        border-bottom: .1875rem solid #fff;
                    }
                }
            }
            .topHead{
                display: flex;
                width: 100%;
                .traLeft{
                    width: 50%;
                    img{
                        display:block;
                        width: 100%;
                        height: 49.375rem;
                    }
                }
            .traRight{
                    width: 50%;
                    .rightBox{
                        width: 100%;
                        height: 49.375rem;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        background: #DCDCDC;
                        .rightIcon{
                            width: 3.75rem;
                            height: 3.75rem;
                            background-image: url(http://comit.oss-cn-hangzhou.aliyuncs.com/img/icon_gjys.png);
                            background-repeat: no-repeat;
                            background-size: 100% 100%;
                            background-position: center center;
                            margin-bottom: 2.625rem;
                        }
                        .rightText{
                            height: 2.1875rem;
                            line-height: 2.1875rem;
                            box-sizing: border-box;
                            font-size: 2.1875rem;
                            margin-bottom: 2.3125rem;
                        }
                        .rightBottom{
                            width: 3.5rem;
                            border-bottom: .1875rem solid #222;
                        }
                    }
                    .rightBox:nth-child(2){
                        background: #018CF4;
                        .rightIcon{
                            background-image: url(http://comit.oss-cn-hangzhou.aliyuncs.com/img/icon_zwgl.png);
                        }
                        .rightText{
                            color: #fff;
                        }
                        .rightBottom{
                            border-bottom: .1875rem solid #fff;
                        }
                    }
                    .rightBox:nth-child(3){
                        background: #222;
                        .rightIcon{
                            background-image: url(http://comit.oss-cn-hangzhou.aliyuncs.com/img/icon_zwfw.png);
                        }
                        .rightText{
                            color: #fff;
                        }
                        .rightBottom{
                            border-bottom: .1875rem solid #fff;
                        }
                    }
                }
            }
            // .box3{
            //     width: 100%;
            //     position:relative;
            // }
            // .box3 #H7FocusImages{
            //     position: absolute;
            //     top: 0px;
            //     width: 50%;
            //     height: 100%;
            //     overflow: hidden;
            // }
            // .box3 #H7FocusImages img{
            //     position: absolute;
            //     left:0px;
            //     width:100%;
            // }
            // .box3 #H7FocusImages .threed{
            //     transform: translate3d(0,0,0);
            //     -ms-transform: translate3d(0,0,0);
            //     -webkit-transform: translate3d(0,0,0);
            //     backface-visibility: hidden;
            //     -webkit-backface-visibility: hidden;
            //     -moz-backface-visibility: hidden;
            //     -ms-backface-visibility: hidden;
            // }
            // .box3 #H7FocusTexts{
            //     position: absolute;
            //     top: 0px;
            //     height: 100%;
            //     width: 50%;
            //     text-align: center;
            //     margin-left: 50%;
            //     overflow: hidden;
            //     background-color: #333;
            //     -webkit-transition:background-color .3s ease;
            //     -moz-transition:background-color .3s ease;
            //     transition:background-color .3s ease;
            // }
            // .box3 .text{
            //     color: #fff;
            //     text-align: center;
            //     width:100%;
            //     position: absolute;
            // }
            // .box3 .text.black{
            //     color: #000;
            // }
            // .box3 .text h2{
            //     font-size:14px;
            //     font-weight: normal;
            //     margin-bottom: 25px;
            //     padding-bottom: 15px;
            //     position: relative;
            // }
            
            // .box3 .text h1{
            //     font-size:40px;
            //     font-weight:bold;
            //     padding-bottom:35px;
            //     position: relative;
            // }
            // .box3 .text img{
            //     display: inline-block;
            //     width:60px;
            //     height:auto;
            //     margin-bottom:40px;
            // }
            // .box3 .text h1:after{
            //     content: "";
            //     position: absolute;
            //     bottom: 0;
            //     left: 50%;
            //     margin-left: -20px;
            //     width:40px;
            //     height: 2px;
            //     background-color: #fff;
            // }
            // .box3 .text.black h1:after{
            //     background-color: #000;
            // }
            // .box3 .text p{
            //     font-size:18px;
            //     line-height:26px;
            //     margin-top:35px;
            // }
        }
        .midBox{
            width: 75rem;
            margin: auto;
            height: 51.8125rem;
            box-sizing: border-box;
            padding-top: 7.4375rem;
            .midText{
                width: 100%;
                margin-bottom: 4.3125rem;
                h3{
                    font-size: 2.625rem;
                    color: #333;
                    line-height: 2.625rem;
                    margin-bottom: 1.6875rem;
                }
                p{
                    font-size: 1.375rem;
                    height: 2.125rem;
                    line-height: 2.125rem;
                    color: rgba(102,102,102,1);
                }
            }
            .midCon{
                display: flex;
                justify-content: space-between;
                .conBox{
                    width: 17.8125rem;
                    text-align: left;
                    img{
                        width: 100%;
                        height: 10.375rem;
                        display: block;
                        margin-bottom: 1.6875rem;
                    }
                    h3{
                        color: #018CF4;
                        font-size: 1.75rem;
                        font-weight: bold;
                        margin-bottom: 1.4375rem;
                    }
                    p{
                        font-size: 1rem;
                        line-height: 1.875rem;
                        color: rgba(51,51,51,1);
                        padding-right: .9375rem;
                    }
                }
            }
        }
        .advantage{
            height: 64.4375rem;
            width: 100%;
            background: rgba(242,242,242,1);
            .content{
                width: 75rem;
                margin: auto;
                padding-top: 7.4375rem;
                .advText{
                    width: 100%;
                    margin-bottom: 4.3125rem;
                    h3{
                        font-size: 2.625rem;
                        color: #333;
                        line-height: 2.625rem;
                        margin-bottom: 1.6875rem;
                    }
                    p{
                        font-size: 1.375rem;
                        height: 2.125rem;
                        line-height: 2.125rem;
                        color: rgba(102,102,102,1);
                    }
                }
                .advCon{
                    width: 100%;
                    height: 35.4375rem;
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: space-between;
                    align-content: space-between;
                    .advBox{
                        width: 17.8125rem;
                        height: 17.0625rem;
                        overflow: hidden;
                        color: #fff;
                        position: relative;
                        .advNor{
                            width: 100%;
                            height: 100%;
                            background-image: url(http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_jthyz.png);
                            background-repeat:  no-repeat;
                            background-position: center center;
                            background-size: 100% 100%;
                            box-sizing: border-box;
                            overflow: hidden;
                            padding-top: 6.0625rem;
                            .icon{
                                width: 2.875rem;
                                height: 2.875rem;
                                display: block;
                                margin: auto;
                                margin-bottom: .9375rem;
                                background-image: url(http://comit.oss-cn-hangzhou.aliyuncs.com/img/szjt_icon_ys.png);
                                background-repeat: no-repeat;
                                background-position: -1.9375rem -1.875rem;
                            }
                            p{
                                font-size: 1.125rem;
                                line-height: 1.125rem;
                            }
                            
                        }
                        .advAct{
                            width: 100%;
                            height: 100%;
                            position: absolute;
                            transition: top 1.5s;
                            background: rgb(48, 156, 238);
                            padding-top: 2.4375rem;
                            box-sizing: border-box;
                            overflow: hidden;
                            top: 100%;
                            .icon{
                                width: 2.875rem;
                                height: 2.875rem;
                                display: block;
                                margin: auto;
                                margin-bottom: .9375rem;
                                background-image: url(http://comit.oss-cn-hangzhou.aliyuncs.com/img/szjt_icon_ys.png);
                                background-repeat: no-repeat;
                                background-position: -1.9375rem -1.875rem;
                            }
                            h3{
                                font-size: 1.125rem;
                                line-height: 1.125rem;
                                margin-bottom: 1.875rem;
                            }
                            p{
                                font-size: .875rem;
                                line-height: 1.6em;
                                width: 14rem;
                                margin: auto;
                                text-align: left;
                            }
                        }
                    }
                    .advBox:nth-child(2){
                        .advNor{
                            background-image: url(http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_zhjs.png);
                            .icon{
                                background-position: -8.8125rem -1.875rem;
                            }
                        }
                        .advAct{
                            .icon{
                                background-position: -8.8125rem -1.875rem;
                            }
                        }
                    }
                    .advBox:nth-child(3){
                        .advNor{
                            background-image: url(http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_dlxx.png);
                            .icon{
                                background-position: -15.75rem -1.875rem;
                            }
                        }
                        .advAct{
                            .icon{
                                background-position: -15.75rem -1.875rem;
                            }
                        }
                    }
                    .advBox:nth-child(4){
                        .advNor{
                            background-image: url(http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_ydkf.png);
                            .icon{
                                background-position: -22.6875rem -1.875rem;
                            }
                        }
                        .advAct{
                            .icon{
                                background-position: -22.6875rem -1.875rem;
                            }
                        }
                    }
                    .advBox:nth-child(5){
                        .advNor{
                            background-image: url(http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_ai.png);
                            .icon{
                                background-position: -2.0625rem -8.8125rem;
                            }
                        }
                        .advAct{
                            .icon{
                                background-position: -2.0625rem -8.8125rem;
                            }
                        }
                    }
                    .advBox:nth-child(6){
                        .advNor{
                            background-image: url(http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_dsj.png);
                            .icon{
                                background-position: -8.8125rem -8.8125rem;
                            }
                        }
                        .advAct{
                            .icon{
                                background-position: -8.8125rem -8.8125rem;
                            }
                        }
                    }
                    .advBox:nth-child(7){
                        .advNor{
                            background-image: url(http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_qkljs.png);
                            .icon{
                                background-position: -15.75rem -8.8125rem;
                            }
                        }
                        .advAct{
                            .icon{
                                background-position: -15.75rem -8.8125rem;
                            }
                        }
                    }
                    .advBox:nth-child(8){
                        .advNor{
                            background-image: url(http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_wlw.png);
                            .icon{
                                background-position: -22.6875rem -8.8125rem;
                            }
                        }
                        .advAct{
                            .icon{
                                background-position: -22.6875rem -8.8125rem;
                            }
                        }
                    }
                    .advBox:hover{
                        .advAct{
                            top: 0;
                        }
                    }
                }
            }
        }
        .service{
            height: 54.5rem;
            width: 100%;
            .content{
                width: 75rem;
                margin: auto;
                padding-top: 7.4375rem;
                .serText{
                    width: 100%;
                    margin-bottom: 4.3125rem;
                    h3{
                        font-size: 2.625rem;
                        color: #333;
                        line-height: 2.625rem;
                        margin-bottom: 1.6875rem;
                    }
                    p{
                        font-size: 1.375rem;
                        height: 2.125rem;
                        line-height: 2.125rem;
                        color: rgba(102,102,102,1);
                    }
                }
                .serCon{
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    .serBox{
                        width: 23.3125rem;
                        height: 27rem;
                        box-shadow: 0 0 1.25rem #ccc;
                        img{
                            width: 100%;
                            height: 14.0625rem;
                            margin-bottom: 2.4375rem;
                            display: block;
                        }
                        div{
                            margin-bottom: 1.6875rem;
                            h3{
                                font-size: 1.5rem;
                                line-height: 1.5rem;
                            }
                        }
                        p{
                            width: 16.5625rem;
                            text-align: left;
                            font-size: 1rem;
                            color: #999;
                            line-height: 2rem;
                            margin: auto;
                        }
                    }
                }
            }
        }
    }
</style>